@let onCatalogRoute = routerSelectors.routeNameMatches('CATALOG') | select;
@let onRegistrationRoute = routerSelectors.routeNameMatches('REGISTER', 'REGISTER_EXISTING_CARD', 'REGISTER_VERIFY_EMAIL_LANDING') | select;
@let isMdOrAbove = viewportSelectors.isMdAndUp | select;
@let isLg = viewportSelectors.isLgAndUp | select;
<div class="h-[3.75rem] md:h-[4.25rem] flex flex-row items-center">
  @if (organizationSelectors.loaded | select) {
    @if (organizationSelectors.hasBanner | select) {
      <div class="relative w-[18.75rem] lg:w-[25rem] h-full">
        <img [ngSrc]="organizationSelectors.bannerUrl | select:''" fill priority [alt]="organizationSelectors.name | select"
             class="object-contain object-center"/>
      </div>
    } @else {
      <span class="text-headline-small">{{ organizationSelectors.name | select }}</span>
    }
  }
</div>
<!-- Don't show the search controls on registration or the Catalog route on sm/md screen sizes, as there are already search controls in the Catalog header. -->
@if (!onRegistrationRoute && (!onCatalogRoute || isLg)) {
  <mx-search-controls [queryTypes]="CATALOG_SEARCH_QUERY_TYPES" (queryTypeChange)="onQueryTypeChange($event)" (searchSubmit)="onSearchSubmit($event)"
                      [placeholderText]="isMdOrAbove ? 'Enter search term here...' : 'Search for...'" typeParamNameOverride="searchTarget"
                      [showDropShadows]="false" [showBorder]="true" [hasMinWidth]="false" [updateFromRouter]="true" class="lg:max-w-[42.5rem]"/>
}
